import * as React from 'react';
import { connect } from 'react-redux';
import { handleStepBack, setFnolReducer, submitFollowUpQuestions, updateClaimPartyReducer } from '../../../actions/claimSubmitActions';
import './FollowUp.css';

class InjuredParties extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.state = {
            reRender: true,
            hasInjuredParties: undefined,
            submitted: false,
            ischeckedDriver: false,
            checklistChecked: []
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleDriverSelection = this.handleDriverSelection.bind(this);
        this.handleSelectInjury = this.handleSelectInjury.bind(this);
    }

    async handleDriverSelection() {
        await this.props.dispatchAction(setFnolReducer('isDriverInjured', !this.props.claimSubmit.isDriverInjured));
    }

    async handleHasInjury(flag) {
        this.setState({ hasInjuredParties: flag })
    }

    async handleSelectInjury(item: any) {
        item.isInjured = !item.isInjured;
        await this.props.dispatchAction(updateClaimPartyReducer(item.driverType, 'edit', item.id, item));
    }

    async handleSubmit() {
        await this.props.dispatchAction(submitFollowUpQuestions())
    }

    async handleBack() {
        await this.props.dispatchAction(handleStepBack())
    }

    public render() {
        let passengerList = <></>;
        if (this.props.claimSubmit.passengers.length > 0) {
            let counter = 0;
            passengerList = this.props.claimSubmit.passengers.map((item) => {
                counter++;
                return <div className={"injuredContainer noma nopa " + (item.isInjured ? "injuredSelected" : "injuredUnselected")} onClick={() => this.handleSelectInjury(item)} id={"ischeckedPass" + item.id} >
                    <div className="noma nopa ml-10px">
                        <label className="form-check-label font-size-14px font-weight-bold noma cursor-pointer unselectable">
                            Passenger {counter}: <span className="font-weight-normal unselectable">{item.firstName} {item.surname}</span></label>
                    </div>
                </div>
            })
        }

        let disableDone = !((this.state.hasInjuredParties === true && (this.props.claimSubmit.isDriverInjured || this.props.claimSubmit.passengers.find(x => x.isInjured))) || this.state.hasInjuredParties === false);

        return <>
            <div className="col-12 ssp-container-fnol-claim-info ssp-container-fnol-step-header-padding">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-claim-info">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red.png'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                <h3>{this.props.claimSubmit.selectedClaimStep.title}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row col-12 noma nopa glassclaims-parent-row">
                <div className="col-12 nopa">
                    <hr className="hr-minus21px" />
                </div>
                <div className="col nopa">
                    <p className="text-16 glassclaims-intro-p stationary-p"><b>Was anyone {this.props.claimSubmit.isCar ? "in" : "on"} the insured vehicle injured as a result of the incident<br className="fnol-newline" /></b></p>
                </div>
                <div className="nopa text-lg-right glassclaims-button-col">
                    <div className="row noma glassclaims-button-row">
                        <div className="col nopa glassclaims-button-no">
                            <button className={this.state.hasInjuredParties !== undefined && this.state.hasInjuredParties === false ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="injuriesNo" onClick={() => this.handleHasInjury(false)}>No</button>
                        </div>
                        <div className="glassclaims-mobile-gutter nopa"></div>
                        <div className="col nopa glassclaims-button-yes">
                            <button className={this.state.hasInjuredParties !== undefined && this.state.hasInjuredParties === true ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="injuriesYes" onClick={() => this.handleHasInjury(true)}>Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 mt-20px nopa">
                <hr className="hr-minus21px" />
            </div>
            {this.state.hasInjuredParties &&
                <div className="row noma" id="injuredList">
                    <div className="col-12 nopa round">
                        <p className="font-weight-normal mb-20px">Please select the injured party/parties below:</p>
                    <div className={"injuredContainer noma nopa " + (this.props.claimSubmit.isDriverInjured ? "injuredSelected" : "injuredUnselected")} onClick={(e) => this.handleDriverSelection()} id="ischeckedDriver" >
                            <div className="noma nopa ml-10px">
                                <label className="form-check-label font-size-14px font-weight-bold noma cursor-pointer unselectable">
                                {this.props.claimSubmit.isCar ? "Driver" : "Rider"}: <span className="font-weight-normal unselectable">{this.props.claimSubmit.regularDriver.firstName} {this.props.claimSubmit.regularDriver.surname}</span></label>
                            </div>
                        </div>
                    {passengerList}
                    </div>
                </div>
            }
            <div className="col-12 nopa fnol-where-it-happened-buttonholder pb-20px">
                <button className="btn btn-solid-green fnol-buttonreverse-button-next" disabled={disableDone} onClick={this.handleSubmit}>Done</button>
                <button className="btn btn-outline-red fnol-buttonreverse-button-back" onClick={this.handleBack}>Back</button>
            </div>
        </>
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InjuredParties)